import type { MapDispatchToPropsFunction, MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { batchFormSelectToggled } from 'state/batchForm/batchForm.action';
import { formInputDataChangedThunk } from 'state/formData/formData.thunks';
import {
  canEditBatchForm,
  getBatchFormFieldMetadata,
  getBatchFormStatus,
  getBatchFormValidationErrors,
  getBatchResult,
  getExposedBatchFormStatus,
  getFormEnrichedData,
  getFormInputData,
  getFormPendingEnrichmentData,
  getUserPreferencesBatchWorkspaceVersion,
} from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

import type { BatchFormDispatchProps, BatchFormOwnProps, BatchFormStateProps } from './BatchForm.models';

export const mapStateToProps: MapStateToProps<BatchFormStateProps, BatchFormOwnProps, AppState> = (state, ownProps) => {
  const productView = 'Batch';
  const fieldsMetadata = getBatchFormFieldMetadata(state, ownProps.formId);
  const inputData = getFormInputData(state, ownProps.formId);
  const pendingEnrichmentData = getFormPendingEnrichmentData(state, ownProps.formId);
  const enrichedData = getFormEnrichedData(state, ownProps.formId);
  const resultData = getBatchResult(state, ownProps.formId);
  const isDisabled = !canEditBatchForm(state, ownProps.formId);
  const isQuoted = getExposedBatchFormStatus(state, ownProps.formId) === 'Success';
  const validationErrors = getBatchFormValidationErrors(state, ownProps.formId);
  const batchWorkspaceVersion = getUserPreferencesBatchWorkspaceVersion(state);
  const formStatus = getBatchFormStatus(state, ownProps.formId);

  return {
    productView,
    fieldsMetadata,
    enrichedData,
    inputData,
    pendingEnrichmentData,
    resultData,
    isQuoted,
    isDisabled,
    validationErrors,
    batchWorkspaceVersion,
    formStatus,
  };
};

export const mapDispatchToProps: MapDispatchToPropsFunction<BatchFormDispatchProps, BatchFormOwnProps> = (
  dispatch: ThunkDispatch,
  { tabId, formId },
) => ({
  setFieldValue: (key: string, value: unknown) => {
    dispatch(formInputDataChangedThunk(tabId, formId, key, value as Readonly<unknown>));
  },
  toggleSelectForm: (formId: string) => {
    dispatch(batchFormSelectToggled(formId));
  },
});

export const connectedBatchForm = connect<BatchFormStateProps, BatchFormDispatchProps, BatchFormOwnProps, AppState>(
  mapStateToProps,
  mapDispatchToProps,
);
